export enum MessengerStages {
	DIALOGS = 'dialogs',
	DIALOG = 'dialog',
	NEW_DIALOG = 'new_dialog',
}
